import axios from "axios";

// const API_URL = "https://hasan-pulse.onrender.com/api";
const API_URL = "https://hasanpulse-v2-backend.onrender.com/api";
// const API_URL = "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const handleError = (error) => {
  return error.response ? error.response.data : { message: error.message };
};

export const registerUser = async (userData) => {
  try {
    const response = await api.post("/auth/register", userData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const loginUser = async (loginData) => {
  try {
    const response = await api.post("/auth/login", loginData);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await api.put(`/auth/${userId}`, userData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getAllUsers = async () => {
  try {
    const response = await api.get("/auth/users");
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const followUser = async (followerId, followingId) => {
  try {
    const response = await api.post("/auth/follow", {
      followerId,
      followingId,
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const unfollowUser = async (followerId, followingId) => {
  try {
    const response = await api.post("/auth/unfollow", {
      followerId,
      followingId,
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getAllPosts = async () => {
  try {
    const response = await api.get("/posts");
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const getUserPosts = async (userId) => {
  try {
    const response = await api.get(`/posts/${userId}`);
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const createPost = async (postData) => {
  try {
    const response = await api.post("/posts", postData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const deletePost = async (postId) => {
  try {
    const response = await api.delete(`/posts/${postId}/delete`);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const addLikeToPost = async (postId, userId) => {
  try {
    const response = await api.post(`/posts/${postId}/like`, { userId });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};

export const addCommentToPost = async (postId, userId, content) => {
  try {
    const response = await api.post(`/posts/${postId}/comment`, {
      userId,
      content,
    });
    return response.data;
  } catch (error) {
    throw handleError(error);
  }
};
